export var ProfileRole;
(function (ProfileRole) {
    ProfileRole["Doctor"] = "doctor";
    ProfileRole["Patient"] = "patient";
    ProfileRole["Representative"] = "representative";
    ProfileRole["Hotline"] = "hotline";
})(ProfileRole || (ProfileRole = {}));
